export const SITE_URL = 'https://fun-tech.vip';
export const NAME_ZH = '丰科有限公司';
export const NAME_EN = 'Fun Tech CO';
export const ALTERNATE_NAME = ['Fun Tech CO'];
export const EMAIL = 'app@fun-tech.vip';
export const LINE_ID = 'fun-tech.vip';
export const LINE_URL = `https://line.me/ti/p/~${LINE_ID}`;

export const ADDRESS = {
  streetAddress: '中原二街28號18樓',
  addressLocality: '中和區',
  addressRegion: '新北市',
  addressCountry: 'TW',
};

export const ADDRESS_FULL = '新北市中和區中原二街28號18樓';

export const CONTENT_UPDATED_AT = '2026-10-31';
export const COPYRIGHT_YEAR = 2026;

export const SITE_TITLE = '丰科有限公司 Fun Tech CO｜App、網站與 AI 應用開發';
export const SITE_DESCRIPTION =
  '丰科有限公司位於新北市中和區，提供 iOS/Android App、網站平台、資訊系統與生成式 AI 流程自動化開發，並協助 Google Play 正式版權限申請。四個已上線案例可直接體驗。';

export const SERVICES = [
  {
    slug: 'mobile-app',
    name: '手機 App 開發',
    serviceType: 'Mobile Application Development',
    description:
      '提供 iOS 和 Android 原生及跨平台應用開發服務，打造流暢的使用者體驗；並協助 Google Play 封閉測試與正式版權限申請。',
  },
  {
    slug: 'web-platform',
    name: '網頁平台設計',
    serviceType: 'Web Platform Development',
    description: '響應式網頁設計與開發，建立現代化、高效能的網路平台。',
  },
  {
    slug: 'information-system',
    name: '資訊系統建置',
    serviceType: 'Information System Development',
    description: '客製化資訊系統開發，協助企業數位轉型與流程優化。',
  },
  {
    slug: 'ai-automation',
    name: 'AI 應用與流程自動化',
    serviceType: 'AI Application and Workflow Automation',
    description:
      '將生成式 AI 與既有流程接起來，打造可一鍵執行、具備排程能力的自動化管線。',
  },
];

export const KNOWS_ABOUT = [
  'Swift',
  'Kotlin',
  'Flutter',
  'React',
  'Next.js',
  'Node.js',
  'Python',
  'Firebase',
  'PostgreSQL',
  'Cloudflare R2',
  'Cloud Run',
  'Vercel',
];
